const favStorageKey = "D8A7984F-146A-4912-931C-42FEB2108889";
const priceBoardViewModeStorageKey = "058A79D964534A0693264F5B4E555B6A";
const priceBoardIndexModeStorageKey = "D7E8A71BC6B54949A89611B09A2D5621";
const languageStorageKey = "6442047A0753470C83107037F72D197B";
const tabRightModeStorageKey = "12A15545E40E47B1AE5F0853F0EE42B7";
const userStorageKey = "319440F72A0342AFA37381B1C6CDFE0A";
const priceBoardColumnConfigStorageKey = "3D362C1D1B6D4FABB8D4BEE4FE6609CB";
const bondSummarryTabKey = "41552674db4d7a4353c6e247e976da51";
const tabNameCurrentDisplay = "4767649df5c19819274ed2af229447fe";

export const getUserFromStorage = () => {
    try {
        let _value = localStorage.getItem(userStorageKey) ?? "";
        if (_value === undefined || _value === null) {
            _value = "";
        }
        //
        if (_value !== "") {
            return JSON.parse(_value);
        }
    }
    catch {
    }

    return {};
}

export const saveUserToStorage = (objUser) => {
    localStorage.setItem(userStorageKey, JSON.stringify(objUser));
}

export const removeUserFromStorage = () => {
    localStorage.removeItem(userStorageKey);
}

export const getFavSymbolsFromStorage = () => {
    return (localStorage.getItem(favStorageKey) ?? "").split(",");
}

export const addFavSymbol = (dispatch, code) => {
    let _favs = (localStorage.getItem(favStorageKey) ?? "").split(",");
    if (_favs.indexOf(code) < 0) {
        _favs.push(code);
        localStorage.setItem(favStorageKey, _favs.join(","));
    }
    //
    dispatch({
        type: 'ChangePriceBoardFavSymbols',
        payload: _favs
    })
};

export const removeFavSymbol = (dispatch, code) => {
    let _favs = (localStorage.getItem(favStorageKey) ?? "").split(",");
    if (_favs.indexOf(code) >= 0) {
        _favs.splice(_favs.indexOf(code), 1);
        localStorage.setItem(favStorageKey, _favs.join(","));
    }
    //
    dispatch({
        type: "ChangePriceBoardFavSymbols",
        payload: _favs
    })
};


//
export const getPriceBoardViewMode = () => {
    return localStorage.getItem(priceBoardViewModeStorageKey);
}

export const changePriceBoardViewMode = (mode) => {
    localStorage.setItem(priceBoardViewModeStorageKey, mode);
    //
    return {
        type: "ChangePriceBoardViewMode",
        payload: mode
    }
}

//
export const getPriceBoardIndexMode = () => {
    return localStorage.getItem(priceBoardIndexModeStorageKey);
}
export const changePriceBoardIndexMode = (oldMode) => {
    let _newIndexMode = "FULL";
    if (oldMode) {
        if (oldMode === 'HIDDEN') {
            _newIndexMode = 'FULL';
        }
        else if (oldMode === 'INFO') {
            _newIndexMode = 'HIDDEN';
        }
        else if (oldMode === 'FULL') {
            _newIndexMode = 'INFO';
        }
        //
    }
    localStorage.setItem(priceBoardIndexModeStorageKey, _newIndexMode);
    //
    return {
        type: "ChangePriceBoardIndexMode",
        payload: _newIndexMode
    }
}

//
export const setFindSymbol = (dispatch, code) => {
    dispatch({ type: 'SetFindSymbol', payload: code });
}

export const removeFindSymbol = (dispatch, code) => {
    dispatch({ type: 'RemoveFindSymbol', payload: code });
}

export const changeSelectShowInfo = (dispatch, type, code) => {
    dispatch({ type: 'GetInfoOfItem', payload: { type: type, code: code } });
}

export const changeTabRightState = (dispatch, isHidden, tabActive) => {
    dispatch({ type: 'ChangeTabRightState', payload: { hidden: isHidden, tab: tabActive } });
}

//change show hide tab
export const changeTabAutoShow = (dispatch, value) => {
    dispatch({ type: 'ChangeTabAutoShow', payload: value });
}

//
export const showPopupInfo = (dispatch, type, code) => {
    dispatch({ type: 'ShowPopupInfo', payload: { show: true, type: type, code: code } });
}

export const hidePopupInfo = (dispatch) => {
    dispatch({ type: 'HidePopupInfo', payload: null });
}

//
export const showPopupInfoTPRL = (dispatch, type, code) => {
    dispatch({ type: 'ShowPopupInfoTPRL', payload: { show: true, type: type, code: code } });
}

export const hidePopupInfoTPRL = (dispatch) => {
    dispatch({ type: 'HidePopupInfoTPRL', payload: null });
}

export const initIndustries = (industries) => {
    return { type: 'InitIndustries', payload: industries };
}

// Ngon ngu
export const changeLanguage = (dispatch, language) => {
    localStorage.setItem(languageStorageKey, language);
    dispatch({ type: 'ChangeLanguage', payload: language });
}

export const getLanguageFromStorage = (dispatch,) => {
    return localStorage.getItem(languageStorageKey);
}

// Sort dl tren bang
export const changeSortConfig = (dispatch, oldColName, oldSortType, newColName, dataType) => {
    try {
        let newSortColumn = '';
        let newSortType = '';
        let newSortDataType = '';

        if (oldColName === newColName) {
            newSortColumn = newColName;
            if (oldSortType === 'asc') {
                newSortType = 'desc';
            }
            else {
                newSortType = 'asc';
            }
        }
        else {
            newSortColumn = newColName;
            newSortType = 'asc';
        }

        newSortDataType = dataType ?? 'text';
        dispatch({ type: 'ChangePriceBoardSortConfig', payload: { type: newSortType, column: newSortColumn, dataType: newSortDataType } });
    } catch (error) {
    }
}

//configColumnNameTable có dạng
// {
//     symbolColAsc: 'code', // chọn menu sort symbol -> lấy trường code
//     totalQttyColAsc: ''
// }
export const changeSortConfigMenu = (dispatch, configColumnNameTable, curSortMenuItem) => {
    try {
        var colName = configColumnNameTable ? configColumnNameTable[curSortMenuItem] : '';
        var dataType = 'text';
        var typeAsc = 'asc';

        if (curSortMenuItem == 'symbolColAsc'
            || curSortMenuItem == 'totalQttyColAsc'
            || curSortMenuItem == 'foreignBuyColAsc'
            || curSortMenuItem == 'foreignSellColAsc'
        ) {
            typeAsc = 'asc';
        } else {
            typeAsc = 'desc';
        }

        if (curSortMenuItem == 'symbolColAsc' || curSortMenuItem == 'symbolColDesc'
        ) {
            dataType = 'text';
        }
        else {
            dataType = 'number';
        }

        dispatch({ type: 'ChangePriceBoardSortConfig', payload: { type: typeAsc, column: colName, dataType: dataType } });
    } catch (error) {
    }
}

//
export const setForceUpdateTime = (dispatch) => {
    dispatch({ type: 'SetForceUpdateTime', payload: (new Date()).getTime() });
}

//
export const setTabRightMode = (dispatch, mode) => {
    localStorage.setItem(tabRightModeStorageKey, mode);
    dispatch({ type: 'ChangeTabRightMode', payload: mode });
}

export const getTabRightModeFromStore = () => {
    return localStorage.getItem(tabRightModeStorageKey);
}

//
export const SetServerTime = (dispatch, timestampUTC) => {
    dispatch({ type: 'SetServerTime', payload: timestampUTC });
}

export const updateMarketInfos = (data) => {
    return { type: 'UpdateMarketInfos', payload: data };
}

// Price board column config
export const savePriceBoardColumnConfigToStorage = (data) => {
    localStorage.setItem(priceBoardColumnConfigStorageKey, JSON.stringify(data));
}

export const getPriceBoardColumnConfigFromStorage = () => {
    return (localStorage.getItem(priceBoardColumnConfigStorageKey) ?? "");
}

// 
export const updateLoadingStatus = (dispatch, data) => {
    dispatch({ type: "SET_STATUS_LOADING", payload: data });
};

export const updateParamSearchHisTPRLPopup = (dispatch, data) => {
    dispatch({ type: "SET_PARAM_SRC_HIS_POPUP_TPRL_DETAIL", payload: data });
};


export const getSummarySymbolsFromStorage = () => {
    return (localStorage.getItem(bondSummarryTabKey) ?? "").split(",");
}

export const addSummarySymbol = (dispatch, code) => {
    let _summaryBonds = (localStorage.getItem(bondSummarryTabKey) ?? "").split(",");
    if (_summaryBonds.indexOf(code) < 0) {
        _summaryBonds.push(code);
        localStorage.setItem(bondSummarryTabKey, _summaryBonds.join(","));
    }
    //
    dispatch({
        type: 'ChangeSummarySymbols',
        payload: _summaryBonds
    })
};

export const removeSummarySymbol = (dispatch, code) => {
    let _summaryBonds = (localStorage.getItem(bondSummarryTabKey) ?? "").split(",");
    if (_summaryBonds.indexOf(code) >= 0) {
        _summaryBonds.splice(_summaryBonds.indexOf(code), 1);
        localStorage.setItem(bondSummarryTabKey, _summaryBonds.join(","));
    }
    //
    dispatch({
        type: "ChangeSummarySymbols",
        payload: _summaryBonds
    })
};

export const getTabNameCurrentDisplayFromStorage = () => {
    return (localStorage.getItem(tabNameCurrentDisplay) ?? "").split(",");
}

export const updateTabNameCurrent = (dispatch, payload) => {
    localStorage.setItem(tabNameCurrentDisplay, payload?.tabNameDisplay);
    dispatch({ type: 'UpdateTabsName', payload: payload });
};

//
export const saveOrderedCodesByTab = (tabName, orderedCodes) => {
    localStorage.setItem("orderedCodesByTab_" + tabName, orderedCodes);
};

export const getOrderedCodesByTab = (tabName) => {
    return (localStorage.getItem("orderedCodesByTab_" + tabName) ?? "").split(",");
};

//
export const savePinnedCodesByTab = (tabName, orderedCodes) => {
    localStorage.setItem("pinnedCodesByTab_" + tabName, orderedCodes);
};

export const getPinnedCodesByTab = (tabName) => {
    return (localStorage.getItem("pinnedCodesByTab_" + tabName) ?? "").split(",");
};